import '../App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CreateBid } from '../pages/emp/CreateBid';
import { EmpBidListing } from '../pages/emp/EmpBidListing';
import { EmpLogin } from '../pages/emp/EmpLogin';
import { EmpUpdateProfile } from '../pages/emp/EmpUpdateProfile';
import ReactWelcome from '../components/ReactHome';
import ResponsiveAppBar from '../components/AppBar';
import { SellerBidListingForEmp } from '../pages/emp/SellerBidListingForEmp';
import { SellersGroupListing } from '../pages/emp/SellersGroupListing';
import { CreateSellersGroup } from '../pages/emp/CreateSellersGroup';
import { SellerReqOtpToLogin } from '../pages/seller/SellerReqOtpToLogin'
import { SellerLogin } from '../pages/seller/SellerLogin'
import { SellerLogout } from '../pages/seller/SellerLogout'
import { SellerUpdateProfile } from '../pages/seller/SellerUpdateProfile'
import { SellerBidListing } from '../pages/seller/SellerBidListing'
import { SellerEmpBidListing } from '../pages/seller/SellerEmpListing'
import { SellerRegister } from '../pages/seller/SellerRegister';
import { SellerResponseOnBid } from '../pages/seller/SellerResponseOnBid';
import { SellerFeedback } from '../pages/seller/SellerFeedback'
import { useEffect, useState } from 'react';
import authUtil from '../utils/auth_util';
import { setAuthUser } from '../stores/AuthUserSlice';
import { useDispatch } from "react-redux";
import { RedirectToHome } from "../pages/seller/RedirectToHome"
// import { useSelector } from "react-redux";


export default function Layout({ children }) {

    const dispatch = useDispatch();
    // const { auth_user } = useSelector((state) => state.authUser);
    // console.log('---auth_user:', auth_user);

    // const [sessionPayload, setSessionPayload] = useState()
    // const [sessionPayloadJson, setSessionPayloadJson] = useState()
    
    useEffect(() => {
        // if (!auth_user) {
        const sessionPayload = authUtil.getCredentials('session-payload')
        // console.log('---Layout.js--sessionPayload:', sessionPayload);
        // setSessionPayload(authUtil.getCredentials('session-payload'))
        if (sessionPayload !== undefined && sessionPayload !== '' && sessionPayload) {
            const sessionPayloadJson = JSON.parse(sessionPayload)
            // setSessionPayloadJson(JSON.parse(sessionPayload))
            dispatch(setAuthUser(sessionPayloadJson))
        }
        // }
    }, []);

    return (
        <>
            {/* <Navbar />
        <main>{children}</main>
        <Footer /> */}

            <ResponsiveAppBar />

            <BrowserRouter>
                <Routes>
                    <Route exact path="/" element={<RedirectToHome />} />
                    {/* <Redirect exact from="/" to="/seller/emp-bid-listing" /> */}
                    <Route exact path="/react-welcome" element={<ReactWelcome />} />
                    {/* <Route exact path="/about" element={<About />} /> */}

                    {/* -> Emp Routes */}
                    <Route exact path="/emp/login" element={<EmpLogin />} />
                    <Route exact path="/emp/update-profile" element={<EmpUpdateProfile />} />
                    {/* <Route exact path="/emp/home" element={<BidList />} /> */}
                    <Route exact path="/emp/create-bid" element={<CreateBid />} />
                    <Route exact path="/emp/bid-listing" element={<EmpBidListing />} />
                    <Route exact path="/emp/sellers-bid-listing" element={<SellerBidListingForEmp />} />
                    <Route exact path="/emp/sellers-group-listing" element={<SellersGroupListing />} />
                    <Route exact path="/emp/create-sellers-group" element={<CreateSellersGroup />} />

                    {/* -> Seller Routes */}
                    <Route exact path="/seller/register" element={<SellerRegister />} />
                    <Route exact path="/seller/request-otp-to-login" element={<SellerReqOtpToLogin />} />
                    <Route exact path="/seller/login" element={<SellerLogin />} />
                    <Route exact path="/seller/logout" element={<SellerLogout />} />
                    <Route exact path="/seller/update-profile" element={<SellerUpdateProfile />} />
                    <Route exact path="/seller/emp-bid-listing" element={<SellerEmpBidListing />} />
                    <Route exact path="/seller/response-on-bid/:bidByEmpId" element={<SellerResponseOnBid />} />
                    <Route exact path="/seller/bid-listing" element={<SellerBidListing />} />
                    <Route exact path="/seller/feedback" element={<SellerFeedback />} />

                </Routes>
            </BrowserRouter>

            {/* <main>{children}</main> */}
        </>
    )
}